// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3fOVw","location":"Header_location__1tKwO"};